export default "__VITE_ASSET__7ac5adaf__"